import { render, staticRenderFns } from "./SendDocumentRegister.vue?vue&type=template&id=50596252&scoped=true&lang=pug"
import script from "./SendDocumentRegister.vue?vue&type=script&lang=ts"
export * from "./SendDocumentRegister.vue?vue&type=script&lang=ts"
import style0 from "./SendDocumentRegister.vue?vue&type=style&index=0&id=50596252&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50596252",
  null
  
)

export default component.exports